import {
  ApolloClient,
  createHttpLink,
  defaultDataIdFromObject,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { readAccessTokenFromCookie } from 'auth/auth-cookie';
import { apolloAuthErrorLink } from './auth-error-link';
import { apolloNetworkStatusLink } from './network-status';

const GRAPHQL_URL =
  process.env.REACT_APP_API_GRAPHQL_URL ?? 'http://localhost:3000/graphql';

const httpLink = createHttpLink({
  uri: GRAPHQL_URL,
  credentials: 'include',
});

const authLink = setContext((_, { headers }) => {
  const accessToken = readAccessTokenFromCookie();

  return {
    headers: {
      ...headers,
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
  };
});

export const apolloClient = new ApolloClient({
  link: apolloNetworkStatusLink.concat(apolloAuthErrorLink).concat(authLink).concat(httpLink),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
    },
  },
  cache: new InMemoryCache({
    dataIdFromObject(responseObject) {
      if (
        typeof responseObject.__typename === 'string' &&
        typeof (responseObject as { uuid?: unknown }).uuid === 'string'
      ) {
        return `${responseObject.__typename}:${(responseObject as { uuid: string }).uuid}`;
      }

      return defaultDataIdFromObject(responseObject);
    },
  }),
});
